import React, { useEffect, useMemo, useRef, useState } from 'react';

import { makeStyles, Button } from '@material-ui/core';

import Table from '../common/Table';

const useStyles = makeStyles(() => {
  return {
    buttonContainer: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'flex-end',
    },

    buttonEdit: {
      marginRight: '8px',
    },
  };
});

export default ({ discounts, total, onCriteriaChange, searchCriteria, onDeleteClick, onEditClick }) => {
  const classes = useStyles();

  const columns = useMemo(
    () => [
      {
        label: 'Name',
        name: 'name',
      },
      {
        label: 'Coupon Code',
        name: 'code',
      },
      {
        label: 'Actions',
        name: 'id',
        options: {
          customBodyRender: (value) => {
            return (
              <div className={classes.buttonContainer}>
                <Button variant="outlined" size="small" onClick={() => onEditClick(value)} className={classes.buttonEdit}>
                  Edit
                </Button>
                <Button variant="contained" size="small" color="secondary" onClick={() => onDeleteClick(value)}>
                  Delete
                </Button>
              </div>
            );
          },

          customHeadRender: () => {
            return (
              <th className="text-right" style={{ fontSize: '0.875rem', fontWeight: 'bold', lineHeight: '1.5rem', padding: '4px 16px' }}>
                Actions
              </th>
            );
          },
        },
      },
    ],
    [onDeleteClick, onEditClick, classes]
  );

  const [tableOptions, setTableOptions] = useState({ page: searchCriteria.page, serverSide: true, total });
  const tableOptionsRef = useRef(tableOptions);

  useEffect(() => {
    tableOptionsRef.current = tableOptions;
  }, [tableOptions]);

  useEffect(() => {
    setTableOptions({
      ...tableOptionsRef.current,
      count: total,
      onTableChange: (action, tableState) => {
        const criteria = {};
        switch (action) {
          case 'sort':
            criteria.orderType = tableState.sortOrder.direction.toUpperCase();
            criteria.orderField = tableState.sortOrder.name;
            break;
          case 'changePage':
            criteria.page = tableState.page;
            break;
          case 'changeRowsPerPage':
            criteria.limit = tableState.rowsPerPage;
            break;
          default:
            return;
        }

        onCriteriaChange(criteria);
      },
      page: searchCriteria?.page,
      rowsPerPage: searchCriteria?.limit || 10,
    });
  }, [total, searchCriteria, onCriteriaChange]);

  return <Table className="small-padding-table" columns={columns} data={discounts || []} options={tableOptions} />;
};
